import React, { useState } from "react"
import styled from "styled-components"
import { AiFillPlayCircle } from "@react-icons/all-files/ai/AiFillPlayCircle"
import { BiChevronLeft } from "@react-icons/all-files/bi/BiChevronLeft"
import { BiChevronRight } from "@react-icons/all-files/bi/BiChevronRight"
import { BsSearch } from "@react-icons/all-files/bs/BsSearch"
import { FaBars } from "@react-icons/all-files/fa/FaBars"
import { FaTimes } from "@react-icons/all-files/fa/FaTimes"
import { FiShoppingCart } from "@react-icons/all-files/fi/FiShoppingCart"
import { Button } from "../../reusableComponents/Button"

// const NAV_LINKS = ["About", "Blog", "Pages", "Team", "Contact"];

const SLIDES = [
  {
    label: "Book-to-screen",
    title: ["Turn Your Story", "Into A Trailer"],
    meta: ["Book Trailer", "2026", "Romance, Drama"],
    description:
      "Writers Way Solutions creates cinematic book trailers that capture the heart of your story and spark interest before the first page is opened.",
    image:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1920&q=80",
  },
  {
    label: "Genre specialists",
    title: ["Every Genre", "Told Cinematically"],
    meta: ["Concept Design", "2026", "Mystery, Thriller"],
    description:
      "From thrillers and fantasy to memoirs and romance, we build trailers that spotlight tension, emotion, and the unique hook of your book.",
    image:
      "https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=1920&q=80",
  },
  {
    label: "Showcase your work",
    title: ["Cinematic Teasers", "For Authors"],
    meta: ["Marketing Ready", "2026", "Fantasy, Biography"],
    description:
      "Your manuscript deserves a trailer that sells the emotion, stakes, and worldbuilding behind it — and we craft that visual hook with precision.",
    image:
      "https://images.unsplash.com/photo-1524985069026-dd778a71c7b4?auto=format&fit=crop&w=1920&q=80",
  },
]

const SHOWS = [
  {
    genre: "Children's Book Trailer",
    title: "Clare's Tomato - Ed Keller",
    season: "Children",
    videoUrl: "https://www.youtube.com/watch?v=9n8WkibxBNA",
    image:
      "https://res.cloudinary.com/domah6aab/image/upload/v1790295244/ChatGPT_Image_Sep_25_2026_08_10_36_AM_eawegq.png",
  },
  {
    genre: "Sci-Fi",
    title: "Into the Battle",
    season: "Cinematic Sci-Fi Story",
    videoUrl: "https://www.youtube.com/watch?v=rSWVShOBiS0",
    image:
      "https://res.cloudinary.com/domah6aab/image/upload/v1790293187/into_the_battle_v3dn0j.png",
  },
  {
    genre: "Action Fantasy Book Trailer",
    title: "The Last Survivors",
    season: "Cinematic Book Trailer",
    videoUrl: "https://www.youtube.com/watch?v=c7i4fIHOK1s",
    image:
      "https://res.cloudinary.com/domah6aab/image/upload/v1790293576/the_last_survivor_jbtrib.png",
  },
  {
    genre: "Action Sci-Fi",
    title: "NEEO",
    season: "Cinematic Action Sci-Fi Story",
    videoUrl: "https://www.youtube.com/watch?v=cS8Ek-J0ueU",
    image:
      "https://res.cloudinary.com/domah6aab/image/upload/v1790292423/neeo_final_sycc3z.png",
  },
  {
    genre: "Children",
    title: "A Little Adventure",
    season: "Cinematic Children's Story",
    videoUrl: "https://www.youtube.com/watch?v=3U7MQF0SWiE",
    image:
      "https://res.cloudinary.com/domah6aab/image/upload/v1790292720/a_little_adventure_ytbmhe.png",
  },
  {
    genre: "Thriller Book Trailer",
    title:
      "Through Angela's Eye The inside story of Operation Firewall - Angela Hart",
    season: "Thriller",
    videoUrl: "https://www.youtube.com/watch?v=Wt3T72l3wBk",
    image:
      "https://res.cloudinary.com/domah6aab/image/upload/v1790293869/Through_Angela_s_Eye_The_inside_story_of_Operation_Firewall_audnfc.png",
  },
]

const getYoutubeEmbedUrl = url => {
  const match = url.match(/[?&]v=([^&#]+)/)
  const videoId = match ? match[1] : "9n8WkibxBNA"
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`
}

export default function MovieTrailerPage() {
  const [slide, setSlide] = useState(0)
  const [menuOpen, setMenuOpen] = useState(false)
  const [activeVideo, setActiveVideo] = useState(null)
  const current = SLIDES[slide]

  const prevSlide = () =>
    setSlide(value => (value - 1 + SLIDES.length) % SLIDES.length)
  const nextSlide = () => setSlide(value => (value + 1) % SLIDES.length)
  const openVideo = url => setActiveVideo(getYoutubeEmbedUrl(url))
  const closeVideo = () => setActiveVideo(null)

  return (
    <Page>
      {/* <Header>
        <NavBar>
          <Logo href="#">
            <LogoMark><AiFillPlayCircle size={16} /></LogoMark>
            <LogoText>Play Show</LogoText>
          </Logo>

          <DesktopNav>
            {NAV_LINKS.map((link) => <NavLink key={link} href="#">{link}</NavLink>)}
          </DesktopNav>

          <Actions>
            <IconButton aria-label="Search"><BsSearch size={20} /></IconButton>
            <CartButton aria-label="Cart">
              <FiShoppingCart size={20} />
              <CartCount>2</CartCount>
            </CartButton>
            <AccountLink href="#"><StatusDot />Account</AccountLink>
            <MenuButton aria-label="Menu" onClick={() => setMenuOpen((open) => !open)}>
              {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </MenuButton>
          </Actions>
        </NavBar>

        {menuOpen && (
          <MobileNav>
            {NAV_LINKS.map((link) => <NavLink key={link} href="#">{link}</NavLink>)}
            <MobileAccount href="#">Account</MobileAccount>
          </MobileNav>
        )}
      </Header> */}

      <Hero>
        <HeroImage
          key={current.image}
          src={current.image}
          alt={current.title.join(" ")}
          className={slide === 2 ? "image-position-bottom" : ""}
        />
        <HeroShade />
        <HeroInner>
          <HeroCopy>
            <Eyebrow>{current.label}</Eyebrow>
            <HeroTitle>
              {current.title[0]}
              <br />
              {current.title[1]}
            </HeroTitle>
            <MetaRow>
              <Quality>
                <PlayCircle>
                  <AiFillPlayCircle size={12} />
                </PlayCircle>
                {current.meta[0]}
              </Quality>
              <MetaMuted>{current.meta[1]}</MetaMuted>
              <MetaAccent>{current.meta[2]}</MetaAccent>
            </MetaRow>
            <Description>{current.description}</Description>
            <PrimaryLink href="#watch">
              <AiFillPlayCircle size={16} />
              Play Trailer
            </PrimaryLink>
          </HeroCopy>

          <SliderControls>
            <SliderButton aria-label="Previous slide" onClick={prevSlide}>
              <BiChevronLeft size={20} />
            </SliderButton>
            <SliderButton aria-label="Next slide" onClick={nextSlide}>
              <BiChevronRight size={20} />
            </SliderButton>
          </SliderControls>

          <Dots>
            {SLIDES.map((item, index) => (
              <Dot
                key={item.label}
                aria-label={`Go to slide ${index + 1}`}
                aria-current={index === slide}
                $active={index === slide}
                onClick={() => setSlide(index)}
              />
            ))}
          </Dots>
        </HeroInner>
      </Hero>

      <ShowsSection id="watch">
        <SectionEyebrow>Book trailer showcase</SectionEyebrow>
        <SectionTitle>Genres We Turn Into Movie Trailers</SectionTitle>
        <ShowsGrid>
          {SHOWS.map(show => (
            <ShowCard
              key={show.title}
              onClick={() => openVideo(show.videoUrl)}
              role="button"
              tabIndex={0}
              onKeyDown={event => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault()
                  openVideo(show.videoUrl)
                }
              }}
            >
              <PosterFrame>
                <Poster src={show.image} alt={show.title} loading="lazy" />
                <Genre>{show.genre}</Genre>
              </PosterFrame>
              <CardBody>
                <ShowTitle>{show.title}</ShowTitle>
                <CardMeta>
                  <Season>{show.season}</Season>
                  <CardPlay
                    aria-label={`Play ${show.title}`}
                    onClick={event => {
                      event.stopPropagation()
                      openVideo(show.videoUrl)
                    }}
                  >
                    <AiFillPlayCircle size={14} />
                  </CardPlay>
                </CardMeta>
              </CardBody>
            </ShowCard>
          ))}
        </ShowsGrid>
      </ShowsSection>

      {activeVideo && (
        <VideoModal onClick={closeVideo}>
          <VideoModalInner onClick={event => event.stopPropagation()}>
            <CloseButton aria-label="Close video" onClick={closeVideo}>
              ×
            </CloseButton>
            <VideoFrame
              src={activeVideo}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </VideoModalInner>
        </VideoModal>
      )}

      <FeatureSection>
        <FeatureInner>
          <FeatureImage
            src="https://res.cloudinary.com/domah6aab/image/upload/v1790294287/cinematic_posters_nhxchr.png"
            alt="Cinema experience"
            loading="lazy"
          />
          <FeatureCopy>
            <FeatureTitle>
              Transform your manuscript into a cinematic book trailer.
            </FeatureTitle>
            <FeatureDescription>
              Writers Way Solutions creates high-impact trailer concepts for
              books in every genre, helping authors turn concept, emotion, and
              story momentum into a visual hook that audiences remember.
            </FeatureDescription>
            <Button to="/contact" round="true" small>
              <AiFillPlayCircle size={16} />
              Get Started
            </Button>
            {/* <PrimaryLink href="/contact">
              <AiFillPlayCircle size={16} />
              Get started
            </PrimaryLink> */}
          </FeatureCopy>
        </FeatureInner>
      </FeatureSection>

      {/* <Footer>
        <FooterInner>
          <Logo href="#"><LogoMark $small><Play size={14} fill="currentColor" /></LogoMark><LogoText>Play Show</LogoText></Logo>
          <Copyright>© {new Date().getFullYear()} Play Show. All rights reserved.</Copyright>
        </FooterInner>
      </Footer> */}
    </Page>
  )
}

const Page = styled.div`
  min-height: 100vh;
  background: #09090b;
  color: #ffffff;
  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  button {
    font: inherit;
  }
`

const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(9, 9, 11, 0.95);
  backdrop-filter: blur(12px);
`

const NavBar = styled.div`
  width: min(100% - 32px, 1280px);
  height: 64px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (min-width: 640px) {
    width: min(100% - 48px, 1280px);
  }
`

const Logo = styled.a`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
`

const LogoMark = styled.span`
  width: ${({ $small }) => ($small ? "28px" : "32px")};
  height: ${({ $small }) => ($small ? "28px" : "32px")};
  display: grid;
  place-items: center;
  border-radius: 4px;
  background: #dc2626;
`

const LogoText = styled.span`
  font-size: 18px;
  font-weight: 700;
`

const DesktopNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 32px;
  @media (max-width: 1023px) {
    display: none;
  }
`

const NavLink = styled.a`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #d4d4d8;
  transition: color 180ms ease;
  &:hover {
    color: #ef4444;
  }
`

const Actions = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 16px;
`

const IconButton = styled.button`
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #d4d4d8;
  cursor: pointer;
  transition: color 180ms ease;
  &:hover {
    color: #ef4444;
  }
`

const CartButton = styled(IconButton)`
  position: relative;
`

const CartCount = styled.span`
  position: absolute;
  top: -7px;
  right: -7px;
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #dc2626;
  font-size: 10px;
  font-weight: 700;
  color: #ffffff;
`

const AccountLink = styled.a`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: #dc2626;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  transition: background 180ms ease;
  &:hover {
    background: #b91c1c;
  }
  @media (max-width: 639px) {
    display: none;
  }
`

const StatusDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffffff;
`

const MenuButton = styled(IconButton)`
  @media (min-width: 1024px) {
    display: none;
  }
`

const MobileNav = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  background: #09090b;
  @media (min-width: 1024px) {
    display: none;
  }
`

const MobileAccount = styled(AccountLink)`
  display: inline-flex;
`

const Hero = styled.section`
  position: relative;
  min-height: 640px;
  overflow: hidden;
  background: #18181b;
  @media (max-width: 639px) {
    min-height: 560px;
  }
`

const HeroImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  &.image-position-bottom {
    object-position: center bottom;
  }
`

const HeroShade = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
      to top,
      #09090b 0%,
      transparent 52%,
      rgba(9, 9, 11, 0.4) 100%
    ),
    linear-gradient(
      to right,
      #09090b 0%,
      rgba(9, 9, 11, 0.8) 52%,
      rgba(9, 9, 11, 0.28) 100%
    );
`

const HeroInner = styled.div`
  position: relative;
  width: min(100% - 32px, 1280px);
  min-height: 640px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 64px 0;
  @media (max-width: 639px) {
    min-height: 560px;
  }
`

const HeroCopy = styled.div`
  max-width: 576px;
`

const Eyebrow = styled.span`
  display: inline-block;
  margin-bottom: 16px;
  padding-left: 12px;
  border-left: 2px solid #dc2626;
  color: #ef4444;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 3px;
`

const HeroTitle = styled.h1`
  margin: 0;
  font-size: 60px;
  line-height: 1.08;
  font-weight: 800;
  letter-spacing: 0;
  @media (max-width: 767px) {
    font-size: 48px;
  }
  @media (max-width: 480px) {
    font-size: 38px;
  }
`

const MetaRow = styled.div`
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
`

const Quality = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #e4e4e7;
`
const PlayCircle = styled.span`
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border: 1px solid #71717a;
  border-radius: 50%;
`
const MetaMuted = styled.span`
  color: #a1a1aa;
`
const MetaAccent = styled.span`
  color: #ef4444;
`

const Description = styled.p`
  max-width: 448px;
  margin: 20px 0 0;
  color: #a1a1aa;
  font-size: 16px;
  line-height: 1.7;
`

const PrimaryLink = styled.a`
  width: fit-content;
  margin-top: 32px;
  padding: 14px 28px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #dc2626;
  color: #ffffff !important;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  transition: background 180ms ease;
  &:hover {
    background: #b91c1c;
  }
  border-radius: 8px;
`

const SliderControls = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 12px;
  @media (max-width: 1023px) {
    position: static;
    margin-top: 40px;
    transform: none;
    flex-direction: row;
  }
`

const SliderButton = styled.button`
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border: 1px solid #52525b;
  background: transparent;
  color: #d4d4d8;
  cursor: pointer;
  transition: 180ms ease;
  &:hover {
    border-color: #dc2626;
    background: #dc2626;
    color: #ffffff;
  }
`

const Dots = styled.div`
  position: absolute;
  left: 0;
  bottom: 40px;
  display: flex;
  gap: 8px;
  @media (max-width: 1023px) {
    position: static;
    margin-top: 28px;
  }
`

const Dot = styled.button`
  width: ${({ $active }) => ($active ? "32px" : "16px")};
  height: 6px;
  padding: 0;
  border: 0;
  background: ${({ $active }) => ($active ? "#dc2626" : "#52525b")};
  cursor: pointer;
  transition: 180ms ease;
`

const ShowsSection = styled.section`
  width: min(100% - 32px, 1280px);
  margin: 0 auto;
  padding: 80px 0;
`

const SectionEyebrow = styled.span`
  color: #ef4444;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 3px;
`

const SectionTitle = styled.h2`
  margin: 8px 0 0;
  font-size: 36px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0;
  @media (max-width: 639px) {
    font-size: 30px;
  }
`

const ShowsGrid = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
  @media (max-width: 1023px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 639px) {
    grid-template-columns: 1fr;
  }
`

const ShowCard = styled.article`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: #18181b;
  cursor: pointer;
  transition: transform 200ms ease, box-shadow 200ms ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.2);
  }
`

const PosterFrame = styled.div`
  position: relative;
  flex: 1;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  background: #27272a;
`

const Poster = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 500ms ease;
  ${ShowCard}:hover & {
    transform: scale(1.05);
  }
`

const Genre = styled.span`
  position: absolute;
  top: 16px;
  left: 0;
  padding: 5px 12px;
  background: #dc2626;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
`

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: auto;
  padding: 16px;
`
const ShowTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  transition: color 180ms ease;
  ${ShowCard}:hover & {
    color: #ef4444;
  }
`
const CardMeta = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const Season = styled.span`
  color: #71717a;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
`
const CardPlay = styled.button`
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  border: 0;
  border-radius: 50%;
  background: #dc2626;
  color: #ffffff;
  cursor: pointer;
  &:hover {
    background: #b91c1c;
  }
`

const VideoModal = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(9, 9, 11, 0.82);
`

const VideoModalInner = styled.div`
  position: relative;
  width: min(90vw, 960px);
  aspect-ratio: 16 / 9;
  border-radius: 18px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45);
`

const VideoFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`

const CloseButton = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 1;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: #111827;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
`

const FeatureSection = styled.section`
  background: #f4f4f5;
  color: #18181b;
`
const FeatureInner = styled.div`
  width: min(100% - 32px, 1280px);
  margin: 0 auto;
  padding: 80px 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  gap: 40px;
  @media (max-width: 899px) {
    grid-template-columns: 1fr;
  }
`
const FeatureImage = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
`
const FeatureCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const FeatureTitle = styled.h2`
  max-width: 560px;
  margin: 0;
  font-size: 36px;
  line-height: 1.35;
  font-weight: 800;
  letter-spacing: 0;
  @media (max-width: 639px) {
    font-size: 30px;
  }
`
const FeatureDescription = styled.p`
  max-width: 448px;
  margin: 16px 0 0;
  color: #71717a;
  font-size: 16px;
  line-height: 1.7;
  padding-bottom: 1rem;
`

const Footer = styled.footer`
  border-top: 1px solid rgba(255, 255, 255, 0.05);
`
const FooterInner = styled.div`
  width: min(100% - 32px, 1280px);
  margin: 0 auto;
  padding: 32px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  @media (max-width: 639px) {
    flex-direction: column;
  }
`
const Copyright = styled.p`
  margin: 0;
  color: #71717a;
  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1.5px;
`
